/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createFolderListResponseFromDiscriminatorValue, createFolderResponse2FromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCreateFolderRequest, serializeFolderResponse2, type CreateFolderRequest, type ErrorResponse, type FolderListResponse, type FolderResponse2, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { type WithFolderItemRequestBuilder, WithFolderItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/folders
 */
export interface FoldersRequestBuilder extends BaseRequestBuilder<FoldersRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.companydocs.folders.item collection
     * @param folderId Unique identifier of the item
     * @returns {WithFolderItemRequestBuilder}
     */
     byFolderId(folderId: string) : WithFolderItemRequestBuilder;
    /**
     * Returns every folder in the organization's library as one flat list, at all depths and in no particular order — build the tree yourself from each folder's parentId, or read its path if a label is all you need. There is no filter or paging. Folders hold no documents in this response; call the documents endpoint with a folderId for a folder's contents.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FolderListResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FolderListResponse | undefined>;
    /**
     * Adds a folder to the organization's document library. Name is required, may run to 255 characters and may not contain '/' or '/' — nesting comes from parentId, never from a name. Leave parentId out to create the folder at the top level; a parentId that does not exist is a bad request. The folder's path is worked out from its parent at the moment it is created and is not recalculated afterwards. Names are not checked for uniqueness, so sending the same name twice creates two sibling folders with the same name and different ids.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<FolderResponse2>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateFolderRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<FolderResponse2 | undefined>;
    /**
     * Returns every folder in the organization's library as one flat list, at all depths and in no particular order — build the tree yourself from each folder's parentId, or read its path if a label is all you need. There is no filter or paging. Folders hold no documents in this response; call the documents endpoint with a folderId for a folder's contents.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Adds a folder to the organization's document library. Name is required, may run to 255 characters and may not contain '/' or '/' — nesting comes from parentId, never from a name. Leave parentId out to create the folder at the top level; a parentId that does not exist is a bad request. The folder's path is worked out from its parent at the moment it is created and is not recalculated afterwards. Names are not checked for uniqueness, so sending the same name twice creates two sibling folders with the same name and different ids.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateFolderRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const FoldersRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/folders";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const FoldersRequestBuilderNavigationMetadata: Record<Exclude<keyof FoldersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byFolderId: {
        requestsMetadata: WithFolderItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["folderId"],
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const FoldersRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: FoldersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFolderListResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: FoldersRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createFolderResponse2FromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateFolderRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
